import { useContext, useState } from "react";
import csvDownload from 'json-to-csv-export';

import { CenteredDiv } from "../../../Global/StyledComponents/AppStyledComponents";
import { ExportIcon } from "../../../Global/Icons/Icons";
import { Form, Header, Input, StyledButton, WarningText } from "../../../Global/StyledComponents/UserFormStyledComponents";
import { formatExportDate, formatPrice, ordinalSuffixOf, round } from "../../../Controllers/utils";
import Loading from "../../../Global/Components/LoadingSpinner";
import { StateContext } from '../../../Controllers/context/state';

const ExportPopUp = () => {
    const [fileName, setFileName] = useState('');
    const [error, setError] = useState(false);
    const {
        cardData,
        loadingExport,
        setShowExportPopUp,
        visibleCards,
        visibleEvents,
        setVisibleEvents,
    } = useContext(StateContext);

    const handleChange = (e) => {
        setError(false);
        setFileName(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!fileName.length) {
            setError(true);

            return;
        }
        
        let exportData;
        let headers;
        if (Object.keys(visibleEvents).length) {
            exportData = Object.keys(visibleEvents).map(key => ({
                publication_time: visibleEvents[key]?.publication_time ? formatExportDate(new Date(visibleEvents[key]?.publication_time)) : '',
                time_utc: visibleEvents[key]?.time_utc ? formatExportDate(new Date(visibleEvents[key]?.time_utc)) : '',
                country: visibleEvents[key]?.country,
                symbol: visibleEvents[key]?.symbol,
                category: visibleEvents[key]?.category,
                status: visibleEvents[key]?.status,
                event: visibleEvents[key]?.event,
                headline: visibleEvents[key]?.headline,
                summary: visibleEvents[key]?.summary,
                unit: visibleEvents[key]?.unit,
                source: visibleEvents[key]?.source,
                importance: visibleEvents[key]?.importance,
                forecast: visibleEvents[key]?.forecast,
                actual: visibleEvents[key]?.actual
            }));
            
            headers = [
                'Published',
                'Event Time',
                'Country',
                'Symbol',
                'Category',
                'Status',
                'Event',
                'Headline',
                'Summary',
                'Unit',
                'Source',
                'Importance',
                'Forecast',
                'Actual'
            ];
        } else {
            exportData = Object.keys(visibleCards).map(key => ({
                symbol: cardData[key]?.symbol,
                name: cardData[key]?.name,
                sector: cardData[key]?.gsector || '',
                subIndustry: cardData[key]?.gsubind || '',
                price: formatPrice(cardData[key]?.close),
                return: `${round(cardData[key]?.date_return_oc * 100, 1)}%`,
                percentileReturn: `${ordinalSuffixOf(round(cardData[key]?.date_return_oc_percentile * 100, 0))}`,
                volAdjReturn: `${round(cardData[key]?.date_return_oc_voladj)}σ`,
                abbreviatedInsight: cardData[key]?.dtm_summary?.dtm_headline || '',
                insights: cardData[key]?.dtm_summary?.dtm_summary || '',
                published: cardData[key]?.dtm_summary?.time_utc ? formatExportDate(new Date(cardData[key]?.dtm_summary?.time_utc)) : '',
            }));

            headers = [
                'Symbol',
                'Name',
                'Sector',
                'Sub Industry',
                'Price',
                'Return',
                'Percentile Return',
                'Volatility Adjusted Return',
                'Abbreviated Insight',
                'Insights',
                'Published',
            ];
        }

        const dataToConvert = {
            data: exportData,
            filename: fileName,
            delimiter: ',',
            headers: headers,
        };

        csvDownload(dataToConvert);
        setShowExportPopUp(false);
        setVisibleEvents({});
    };

     return (
        <Form onSubmit={handleSubmit}>
            <Header>
                Export Data For Listed Assets
            </Header>
            {loadingExport ?
                <Loading /> :
                <CenteredDiv>
                    {Object.keys(visibleCards).join(', ')}
                </CenteredDiv>
            }
            <br />
            <Input onChange={handleChange} placeholder='Enter File Name' style={{ width: '95%', margin: 0 }} type='text' value={fileName}/>
            <br />
            {error &&
                <WarningText>
                    Missing File Name.
                </WarningText>
            }
            <StyledButton disabled={loadingExport} type='submit'>
                Export CSV 
                <ExportIcon />
            </StyledButton>

        </Form>
     )
};

export default ExportPopUp;
